<template lang="pug">
.pop-up-comp.mask(v-show="visible")
  .inner-content
    .title.color_text_1 {{config.text}}
    .btn-ara
      .cancel.btn.color_text_1(@click="cancel") {{ config.cancelButtonText || '取消' }}
      .confirm.btn(@click="confirm") {{ config.confirmButtonText || '确认' }}
</template>
<script>
export default {
  name: 'PopUp',
  data() {
    return {
      visible: false,
      config: '',
    };
  },
  methods: {
    cancel() {
      this.config.cancel();
      this.closePopup();
    },
    confirm() {
      this.config.confirm();
      this.closePopup();
    },
    closePopup() {
      this.visible = false;
      this.config = {};
    },
  },
  mounted() {
    console.log('config', this.config);
  },
};
</script>
<style scoped lang="stylus">
.mask
  position fixed
  left 0
  top 0
  width 100vw
  height 100vh
  background rgba(9, 11, 15, 0.6)
  z-index 99999999
  .inner-content
    position absolute
    left 50%
    top 50%
    transform translate(-50%, -50%)
    background #FFFFFF
    border-radius 12px
    padding 40px 20px
    width: 344px
    min-height: 173px
    box-sizing: border-box
    text-align center
    background-size 100% 100%
    *
      box-sizing: border-box
    .title
      font-weight 400
      font-size 20px
      line-height 28px
    .btn-ara
      display flex
      justify-content: center
      align-items: center
      width 100%
      margin 0 auto
      .btn
        width 96px
        height 36px
        border-radius 8px
        text-align center
        line-height 36px
        margin-top 32px
        cursor pointer
        font-size 14px
        border-radius 8px
        position relative
        &:hover
          &:before
            content ''
            position absolute
            width 100%
            height 100%
            top 0
            left 0
            z-index 10
            background rgba(77, 113, 255, 0.04)
      .cancel
        border 1px solid #DCDFE6
        border-radius 8px
        margin-right 16px
      .confirm
        border 1px solid #F7434D
        border-radius 8px
        color #F7434D
</style>
